import React from "react";
import { useTheme } from "../../theme/ThemeContext";
import styles from "./index.module.scss";

const ThemeSwitcher = ({ className = "" }) => {
  const { themes, themeId, setThemeId } = useTheme();

  return (
    <div className={`${styles.themeControl} ${className}`.trim()}>
      <label htmlFor="theme-switcher" className={styles.themeLabel}>
        主題
      </label>
      <select
        id="theme-switcher"
        className={styles.themeSelect}
        value={themeId}
        onChange={(event) => setThemeId(event.target.value)}
        aria-label="選擇主題色"
      >
        {themes.map((theme) => (
          <option value={theme.id} key={theme.id}>
            {theme.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default ThemeSwitcher;
